import AlexaV3Exception from './AlexaV3Exception';

export default class OverallDailyRateLimitExceeded extends AlexaV3Exception {}
